import { CSSResultGroup, TemplateResult, html } from 'lit';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { customElement, property } from 'lit/decorators.js';
import { SlotController } from '../../controllers/slot-controller';
import { AllowedHeadingLevels } from '../se-heading/config';
import componentStyles from './se-announcement.css.lit';
import '../../base/outline-icon/outline-icon';
import '../se-button/se-button';
import '../se-container/se-container';
import '../se-heading/se-heading';

/**
 * The SeAnnouncement component
 * @element se-announcement
 */
@customElement('se-announcement')
export class SeAnnouncement extends OutlineElement {
  slots = new SlotController(this, true);
  static styles: CSSResultGroup = [componentStyles];

  @property({ type: String })
  heading: string;
  @property({ type: String, attribute: 'heading-level' })
  headingLevel: AllowedHeadingLevels = 'h2';

  announcementImage(): TemplateResult {
    if (this.querySelector('[slot="announcement-image"]')) {
      return html` <div class="se-announcement__image">
        <slot name="announcement-image"></slot>
      </div>`;
    } else {
      return html``;
    }
  }

  announcementContent(): TemplateResult {
    return html`
      <div class="se-announcement__content">
        <div class="se-announcement__title">
          <se-heading
            level="${this.headingLevel}"
            level-style="medium"
            level-size="h1"
            font="rift"
            >${this.heading}</se-heading
          >
        </div>
        <div class="se-announcement__description">
          <slot name="description"></slot>
        </div>
        <div class="se-announcement__link">
          <slot name="link"></slot>
        </div>
      </div>
    `;
  }

  render(): TemplateResult {
    return html`
      <div class="se-announcement">
        ${this.announcementImage()} ${this.announcementContent()}
      </div>
    `;
  }
}
